import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  hasMerchant: boolean = true;
  merchant: string = '';

  constructor(
    private meta: Meta, 
    private http: HttpClient
  ){}

  ngOnInit() {
    let _ = this;
    _.validateMerchant();
  }

  validateMerchant() {
    let _ = this;
    let url: any = location.href.split('/');
    url = url[3];
    if (url === 'christelhousefeenicia') {
      let head = document.getElementsByTagName('head')[0];
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '4488751044587854');
        fbq('track', 'PageView');
      `;
      head.appendChild(script);
    }
  }
}
